export default __webpack_public_path__ + "static/media/Commercial-IMG_7765.c26ffdf5.jpg";